(() => {
  const initStickyBuy = (root = document) => {
    root.querySelectorAll('[data-sua-sticky-buy]').forEach((bar) => {
      if (bar.dataset.suaReady === 'true') return;
      bar.dataset.suaReady = 'true';

      const stickyButton = bar.querySelector('[data-sua-sticky-submit]');
      const targetId = bar.dataset.target;
      let observer;
      let infoObserver;
      let accordionObserver;

      // La barra solo se muestra si el boton principal no se ve,
      // seguimos dentro de la ficha y no hay pestanas (Beneficios, Descripcion, Cuidados) en pantalla.
      const state = { primaryVisible: true, infoVisible: true, accordionsVisible: new Set() };

      const getPrimaryButton = () => document.getElementById(targetId);

      const sync = () => {
        const primaryButton = getPrimaryButton();
        if (!primaryButton || !stickyButton) return;
        stickyButton.disabled = primaryButton.disabled;
        const primaryLabel = primaryButton.querySelector('span');
        const stickyLabel = stickyButton.querySelector('span');
        if (primaryLabel && stickyLabel) {
          stickyLabel.textContent = primaryLabel.textContent.trim();
        }
      };

      const render = () => {
        const show =
          !state.primaryVisible &&
          state.infoVisible &&
          state.accordionsVisible.size === 0 &&
          window.scrollY > 280;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };

      const observePrimaryButton = () => {
        const primaryButton = getPrimaryButton();
        if (!primaryButton) return;
        observer?.disconnect();
        observer = new IntersectionObserver(
          ([entry]) => {
            state.primaryVisible = entry.isIntersecting;
            render();
          },
          { threshold: 0.15 }
        );
        observer.observe(primaryButton);

        infoObserver?.disconnect();
        const info = primaryButton.closest('product-info');
        if (info) {
          infoObserver = new IntersectionObserver(
            ([entry]) => {
              state.infoVisible = entry.isIntersecting;
              render();
            },
            { threshold: 0 }
          );
          infoObserver.observe(info);
        }

        accordionObserver?.disconnect();
        state.accordionsVisible.clear();
        const scope = info || document;
        const accordions = scope.querySelectorAll('.product__accordion, details.accordion, .accordion');
        if (accordions.length) {
          accordionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) state.accordionsVisible.add(entry.target);
                else state.accordionsVisible.delete(entry.target);
              });
              render();
            },
            { threshold: 0 }
          );
          accordions.forEach((el) => accordionObserver.observe(el));
        }
        sync();
      };

      stickyButton?.addEventListener('click', () => {
        const primaryButton = getPrimaryButton();
        if (primaryButton && !primaryButton.disabled) primaryButton.click();
      });

      window.addEventListener('scroll', render, { passive: true });

      document.addEventListener('change', (event) => {
        if (event.target.closest('product-info')) {
          window.setTimeout(() => {
            observePrimaryButton();
            sync();
          }, 120);
        }
      });

      observePrimaryButton();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyBuy());
  } else {
    initStickyBuy();
  }

  document.addEventListener('shopify:section:load', (event) => initStickyBuy(event.target));
})();
